import { Box, SxProps, useTheme } from "@mui/material";
import { ReactNode } from "react";

type Props = {
    hover?: boolean
    sx?: SxProps,
    children: ReactNode | ReactNode[]
}

const TableRow = ({ children, sx, hover = false }: Props) => {
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 2, width: '100%', borderBottom: `1px solid ${theme.palette.divider}`, ...sx }}>
            {children}
        </Box>
    )
}

export default TableRow;